import { useEffect, useState } from 'react';

// RW-1578: reactive mobile detection. Chat components previously did
// one-shot `window.matchMedia(...).matches` reads at render — rotating a
// tablet or resizing a window never updated touch-target sizing until the
// component happened to remount.
export default function useIsMobile(query = '(max-width: 900px)') {
  const [mobile, setMobile] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setMobile(e.matches);
    mql.addEventListener('change', onChange);
    setMobile(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return mobile;
}
